export { default as throttle } from 'lodash.throttle';
export { default as debounce } from 'lodash.debounce';
import { useContext, useLayoutEffect, useEffect } from 'react';
import * as styledComponents from 'styled-components';
import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';

var styled = styledComponents["default"],
  css = styledComponents.css,
  createGlobalStyle = styledComponents.createGlobalStyle,
  keyframes = styledComponents.keyframes,
  ThemeProvider = styledComponents.ThemeProvider,
  withTheme = styledComponents.withTheme,
  ServerStyleSheet = styledComponents.ServerStyleSheet,
  ThemeContext = styledComponents.ThemeContext;
var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};
var isNode = function isNode() {
  return !isBrowser();
};

var createBreakpoint = function createBreakpoint(functionKey) {
  return function (breakpointKey) {
    return function (props) {
      return props.theme.breakpoints[functionKey](breakpointKey);
    };
  };
};
var breakpointUp = createBreakpoint('up');
var breakpoint = breakpointUp;
var breakpointDown = createBreakpoint('down');

var BASE_FONT_SIZE = 16;
var pxToRem = function pxToRem(size) {
  return size / BASE_FONT_SIZE;
};

// istanbul ignore file
var createImage = function createImage(width, height) {
  var fileFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
  return "https://images.ctfassets.net/3m6f3dx67i1j/3ztpsOfoWZXo4j3uVRStpF/2dbebe2dcf4ba0df5cd45b4a9b87164f/fa-image-landscape.png?w=".concat(width, "&h=").concat(height, "&fm=").concat(fileFormat, "&fit=fill");
};

var _templateObject$2;
var aspectRatio = css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: ", ";\n"])), function (props) {
  return "".concat(1 / props.aspectRatio * 100, "%");
});

var _templateObject$1;
var fillAbsolute = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));

var _templateObject;
var screenReaderOnly = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n"])));

var useIsoLayoutEffect = isBrowser() ? useLayoutEffect : useEffect;

export { ServerStyleSheet, ThemeProvider, aspectRatio, breakpoint, breakpointDown, breakpointUp, createGlobalStyle, createImage, css, fillAbsolute, isBrowser, isNode, keyframes, pxToRem, screenReaderOnly, styled, useIsoLayoutEffect, useTheme, withTheme };
